export const getStopColor = (stops: number): string => {
  if (stops === 0) return "green"; // Cor para 0 paradas
  if (stops === 1) return "orange"; // Cor para 1 parada
  if (stops === 2) return "red"; // Cor para 2 paradas
  return "#FF8F86"; // Cor para 3 ou mais paradas
};
